import { QueryClient } from '@tanstack/react-query';

import { ApiProblemError } from './api/slider-fetch';

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (
            error instanceof ApiProblemError &&
            error.status >= 400 &&
            error.status < 500 &&
            error.status !== 429
          ) {
            return false;
          }
          return failureCount < 2;
        },
        staleTime: 30_000,
      },
      mutations: {
        retry: false,
      },
    },
  });
